import React, { useEffect, useState } from 'react';
import { useOnlineStatus } from '../../utils/onlineStatus';
import './pwa.css';

export default function OfflineStatusBanner() {
  const online = useOnlineStatus();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (online) setDismissed(false);
  }, [online]);

  if (online || dismissed) return null;

  return (
    <div className="offline-status-banner" role="status" aria-live="polite">
      <div className="offline-status-banner__content">
        <strong>You are offline</strong>
        <span>Showing saved data where available. Reconnect to make changes.</span>
      </div>
      <button
        type="button"
        className="offline-status-banner__dismiss"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss offline message"
      >
        ×
      </button>
    </div>
  );
}
